import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";
import { AppContext } from "../../utils/context";

class HelpSystemVersion extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      systemVersion: context.config.version
    }
  }
  render() {
    const { systemVersion } = this.state;
    return (
      <Segment basic>
        <Header as="h2">
          <Header.Subheader>
            Current Release: { systemVersion }
          </Header.Subheader>
        </Header>
      </Segment>
    );
  }
}
HelpSystemVersion.contextType = AppContext;

export default HelpSystemVersion;
